import DOMPurify from 'dompurify';

export const replaceMatchedFragments = (match: string) => {
  const sanitized = DOMPurify.sanitize(match);
  return `<mark
class="bg-warning-400 text-black font-bold"
>${sanitized}</mark>`;
};
